
import Component from 'vue-class-component'
import moduleStore from '../store/migu';
import Vue from 'vue';
import PageState from '../store/state';
import StepText from '../components/stepText.vue';
import StepVideoStyle from '../components/stepVideoStyle.vue';
import StepSpeaker from '../components/stepSpeaker.vue';
import SubmitBtn from '../components/submitBtn.vue';
import {
  toast,
  notLoginMessage,
  notLoginErrorMessage,
} from '@/utils/util';
import { MiguConfig } from '../utils/constant';
import to from 'await-to-js';

/**components**/
@Component({
  components: {
    StepText,
    StepVideoStyle,
    StepSpeaker,
    SubmitBtn,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class textToVideoThirdPartPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;
  
  isSubmiting = false;
  taskId = 'test'; // 任务id
  text = '';  // 默认文本
  styleCode = ''; // 默认视频风格
  speakerName = ''; // 默认发音人名称
  speakerStyleId = 0; // 默认发音人风格id
  speechSpeed = ''; // 默认语速
  localStorageKey = 'textToVideoMiguData'; // 本地存储key， 用于数据回显
  submitParamsKey = 'textToVideoMiguSubmitData'; // 用于提交
  submitKey = 'isMiguSubmit'; // 用于判断是否是提交

  // 文本参数
  get textParams() {
    if(!this.$refs.stepTextRef) return {};
    return (this.$refs.stepTextRef as any).submitParams || {};
  }

  // 视频风格参数
  get videoStyleParams() {
    if(!this.$refs.stepVideoStyleRef) return {};
    return (this.$refs.stepVideoStyleRef as any).submitParams || {};
  }

  // 发音人参数
  get speakerParams() {
    if(!this.$refs.stepSpeakerRef) return {};
    return (this.$refs.stepSpeakerRef as any).submitParams || {};
  }

  // 获取提交参数
  getParams() {
    const { text, wordLimit } = this.textParams;
    const { speaker, speakerStyle, speechSpeed } = this.speakerParams;
    const { styleCode, scaleCode, effectCode } = this.videoStyleParams;
    const params: any = {
      creationTaskId: this.taskId,
      originContent: text,
      title: text.slice(0, 80),
      wordLimit,
      styleCode,
      scaleCode,
      effectCode,
      speaker,
      speakerStyle,
      speechSpeed,
      platform: 'MIGU', // UNKNOWN :未知 0 ,MINI :微信小程序 1 ,APP :APP 2 ,PC_BOKAN :博看网 10, MIGU :咪咕 11
      resourceType: 'ONE_CLICK',
      articleTransform: 0,
    };
    return params;
  }
  // 提交
  doSubmit(params?: any) {
    if (this.isSubmiting) return;
    this.isSubmiting = true;
    const bodyParams = params ? params : this.getParams();
    if(!bodyParams.originContent) {
      return toast('请输入文案');
    }
    if(!bodyParams.speaker) {
      return toast('请选择发音人');
    }
    this.$http('submitCreate', bodyParams).then(res => {
      this.isSubmiting = false;
      if (res.code == 200) {
        this.isSubmiting = true;
        //跳转生成状态页面
        this.$router.push({ path: '/audioCreating', query: { articleId: res.data.articleId, source: 'app_migu' } });
      } else if (res.message == notLoginMessage) {
        this.doLogin();
      } else {
        toast(res.message);
      }
    }).catch(err => {
      if (err?.response?.data?.message === notLoginErrorMessage) {
        this.doLogin();
      }
    })
  }

  async getUserInfo() {
    const [err, res] = await to( this.$http('getMiguUser'));
    if (err || res.data !== 200) {
      console.log(err || res.message);
    }
  }

  // 获取本地存储数据，页面跳转回来时，恢复数据
  getLocalStorageData() {
    const data = JSON.parse(localStorage.getItem(this.localStorageKey));
    if (data) {
      const { text, speakerName, speakerStyleId, speechSpeed, styleCode } = data;
      this.text = text;
      this.speakerName = speakerName;
      this.speakerStyleId = speakerStyleId;
      this.speechSpeed = speechSpeed;
      this.styleCode = styleCode;
      localStorage.removeItem(this.localStorageKey);
    }
  }

  // 本地存储数据，跳转其他页面（发音人搜索页）时进行存储
  setLocalStorageData() {
    const { text } = this.textParams;
    const { speakerName, speakerStyleId, speechSpeed } = this.speakerParams;
    const { styleCode } = this.videoStyleParams;
    const data = { text, speakerName, speakerStyleId, speechSpeed, styleCode };
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  // 设置migu数据
  setMiguData() {
    localStorage.removeItem('ww_token');
    localStorage.setItem('isMigu', 'true');
    const query = this.$route.query;
    const btoken = query.btoken || localStorage.getItem('btoken') || '';
    const vuid = query.vuid || localStorage.getItem('vuid')  || '';

    if(btoken && vuid && typeof btoken === 'string' && typeof vuid === 'string') {
      localStorage.setItem('btoken', btoken);
      localStorage.setItem('vuid', vuid);
      this.getUserInfo();
    }
    
    // migu给的参数，除了 btoken 和 vuid，其他参数需要原样回传到视频发布页
    if(query.btoken) {
      const queryString = window.location.href.split('?')[1];
      const params = new URLSearchParams(queryString);
      params.delete('vuid');
      params.delete('btoken');
      localStorage.setItem('queryFromMigu', params.toString());
    }
    if(!btoken) {
      this.doLogin();
      return;
    }
    // this.setTaskId();
  }
  
  // 设置taskId
  setTaskId() {
    const query = this.$route.query;
    const taskId = query.taskId || '';
    if(typeof taskId === 'string') this.taskId = taskId;
    const isMiguSubmit = localStorage.getItem(this.submitKey);
    if(isMiguSubmit && !taskId) {
      const resumeCode = query.resumeCode || '';
      // 用户支付状态码0：用户支付失败, 1：用户支付成功, 2：用户取消支付, 3：用户已有次数, 4：获取taskId失败
      const error = query.info as string;
      if(resumeCode === '4') {
        toast(error || '获取taskId失败');
      }else if(resumeCode === '2') {
        toast(error || '您已取消支付');
      } else if(resumeCode === '0') {
        toast(error || '支付失败');
      }
    }
    if(!isMiguSubmit || !taskId)  return;
    // 有taskId说明是一键成片跳转来的
    const data = JSON.parse(localStorage.getItem(this.submitParamsKey));
    if(!data) return;
    data.creationTaskId = taskId;
    this.doSubmit(data);
    localStorage.removeItem(this.submitKey);
  }

  queryTaskId(isDoSubmit = true) {
    // 已有taskId，直接提交
    if (this.taskId && isDoSubmit) {
      this.doSubmit();
      return;
    }
    // 获取taskId，跳转migu的h5页面，通过cburl跳转回来，并带上taskId
    this.setLocalStorageData(); // 用作内容回显
    if(isDoSubmit) {
      localStorage.setItem(this.submitKey, 'true'); // 用作判断是否接触发提交
      const submitParams = this.getParams(); // 用作跳转回来之后直接触发提交的传参
      localStorage.setItem(this.submitParamsKey, JSON.stringify(submitParams));
    }
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    window.location.href = 
      `https://y.migu.cn/app/v5/p/ai-charging/index.html?appId=${MiguConfig.appid}&cburl=${cburl}&schannel=014025D&pm=hash#/task-id`;
  }
  // 跳转登录，migu的h5页面，根据appId跳转回来（在migu那边配置回调地址是正式环境）
  doLogin() {
    this.setLocalStorageData();
    window.location.href = `https://y.migu.cn/app/v5/p/ai-charging/index.html?appId=${MiguConfig.appid}&schannel=014025D&pm=hash#/entry`;
  }

  created() {
    this.setMiguData();
    this.getLocalStorageData();
  }
}
